require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

var toString = Object.prototype.toString;
module.exports = isString;

function isString(obj) {
  return toString.call(obj) === "[object String]";
}